(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initPopup(){
    var $ = jQuery;
    $('body').on('click', '[data-popup]', function(){
            
        $('body').addClass('is-popup-'+$(this).data('popup')+'-shown');
        $('body').addClass('is-overlay-visible');
    });

    $('[data-cookie-popup]').each(function() {
        //localStorage.setItem("setted",true);
        const popup_name = $(this).data('cookiePopup');
        if (! localStorage.getItem("cookie_"+popup_name)) {
            $('body').addClass('is-popup-'+popup_name+'-shown');
            $('body').addClass('is-overlay-visible');
            localStorage.setItem("cookie_"+popup_name, true);
        }
    });

    $('body').on('click', '.m-popup .close', function(){
        $("body").removeClass(function (index, className) {
            return (className.match (/is-popup-(.*)-shown/g) || []).join(' ');
        });
        $('body').removeClass('is-overlay-visible');
    });
    var $notice = $('.m-notice.is-success').eq(0); msg = $notice.text();
    if ($notice.length) {
        $notice.remove();
        $('.m-popup.is-notice .popup-body').html(msg);
        $('body').addClass('is-popup-notice-shown is-overlay-visible');
    }
}